import { useLanguage } from '../context/LanguageContext';
import { t as translate } from './translations';

export const useT = () => {
  const { language } = useLanguage();
  const t = (key) => translate(key, language);
  t.language = language;
  return t;
};
